export default __webpack_public_path__ + "static/media/IMG_0495.fe6316ee.jpg";